import { render, staticRenderFns } from "./viewResultChangesDetail.vue?vue&type=template&id=6b0491c6&lang=pug"
import script from "./viewResultChangesDetail.vue?vue&type=script&lang=js"
export * from "./viewResultChangesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports